import { render, staticRenderFns } from "./iconBar.vue?vue&type=template&id=20f7d8db&scoped=true&"
import script from "./iconBar.vue?vue&type=script&lang=js&"
export * from "./iconBar.vue?vue&type=script&lang=js&"
import style0 from "./iconBar.vue?vue&type=style&index=0&id=20f7d8db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f7d8db",
  null
  
)

export default component.exports